import { Injectable } from "@angular/core";
import { AuthenticationService } from "../core/authentication/authentication.service";
import { DOC_ACTION, DocActionDto } from "../dto/doc-action-dto";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ConfirmationService } from "../shared/dialog/confirmation.service";
import { TranslateService } from "@ngx-translate/core";
import { HomeFilterService } from "../home/home-filter.service";
import { extract } from "../core/i18n.service";
import { ApiService } from "../core/api/api.service";
import { SnackBarService } from "./snackbar.service";
import { DocDto } from "../dto/doc-dto";
import { ShellEmittersService } from "../shell-emitters.service";

@Injectable({
    providedIn: "root",
})
export class TrashDocService {
    //DEBUG variables
    private FAKE_TRASH: boolean = false;

    private pendingActions: Array<DocActionDto> = [];

    trashRecentSubscription: Subscription | undefined;
    removeRecentSubscription: Subscription | undefined;

    constructor(
        private authenticationService: AuthenticationService,
        private router: Router,
        private confirmationService: ConfirmationService,
        private translateService: TranslateService,
        private apiService: ApiService,
        private homeFilterService: HomeFilterService,
        private snackBarService: SnackBarService,
        private shellEmittersService: ShellEmittersService
    ) { }


    public async trashOp(dto: DocActionDto) {
        if (this.authenticationService.isAuthenticated()) {
            if (dto && dto.recentDocDto && dto.recentAction !== DOC_ACTION.NONE) {
                let res;
                switch (dto.recentAction) {
                    case DOC_ACTION.TRASH:
                        console.log(`***Trash map: ${dto.recentDocDto.name} - ${dto.recentDocDto.id}`);
                        const clone = { ...dto };
                        this.trashRecentGUI(dto.recentDocDto);
                        setTimeout(() => { this.pendingActions.push(clone); }, 500);
                        break;
                    case DOC_ACTION.UNTRASH:
                        console.log(`***Untrash map: ${dto.recentDocDto.name} - ${dto.recentDocDto.id}`);
                        this.untrashRecentGUI(dto.recentDocDto);
                        setTimeout(() => { this.pendingActions.push(dto); }, 500);
                        break;
                    case DOC_ACTION.REMOVE:
                        console.log(`***Remove map: ${dto.recentDocDto.name} - ${dto.recentDocDto.id}`);
                        res = await this.removeRecentGUI(dto.recentDocDto);
                        if (res) {
                            setTimeout(() => { this.pendingActions.push(dto); }, 500);
                        }
                        break;
                    case DOC_ACTION.DELETE:
                        console.log(`***Delete map: ${dto.recentDocDto.name} - ${dto.recentDocDto.id}`);
                        res = await this.deleteRecentGUI(dto.recentDocDto);
                        if (res) {
                            setTimeout(() => { this.pendingActions.push(dto); }, 500);
                        }
                        break;
                }
            }
        } else {
            this.router.navigate(['login']);
        }
    }

    async executePendingActions(notifyClient = true) {
        // Finalizza l'operazione del cestino su DB
        if (this.pendingActions) {
            while (this.pendingActions.length > 0) {
                const action = { ...this.pendingActions[0] };
                this.pendingActions.splice(0, 1);
                console.log(`***Execute pending action: ${action.recentDocDto?.name}, action: ${action.recentAction}`);
                if (action && action.recentDocDto && action.recentAction !== DOC_ACTION.NONE) {
                    let res;
                    switch (action.recentAction) {
                        case DOC_ACTION.TRASH:
                            if (this.FAKE_TRASH) {
                                console.log('***FAKE TRASH***');
                            } else {
                                res = await this.trashOrRestoreRecentOnDB(action.recentDocDto.id, 'trash')
                            }
                            break;
                        case DOC_ACTION.UNTRASH:
                            if (this.FAKE_TRASH) {
                                console.log('***FAKE UNTRASH***');
                            } else {
                                res = await this.trashOrRestoreRecentOnDB(action.recentDocDto.id, 'restore')
                            }
                            break;
                        case DOC_ACTION.REMOVE:
                            // Elimina la mappa dalla lista dell'utente e se è proprietario cancella anche lo storage (in questo caso no)
                            if (this.FAKE_TRASH) {
                                console.log('***FAKE REMOVE***');
                            } else {
                                res = await this.removeOrDeleteRecentOnDB(action.recentDocDto.id);
                            }
                            break;
                        case DOC_ACTION.DELETE:
                            // Elimina la mappa dalla lista dell'utente e se è proprietario cancella anche lo storage (in questo caso sì)
                            if (this.FAKE_TRASH) {
                                console.log('***FAKE DELETE***');
                            } else {
                                res = await this.removeOrDeleteRecentOnDB(action.recentDocDto.id);
                            }
                            break;
                    }
                }
                if (notifyClient) {
                    //TO DO refresh list to all users
                }
            }
        }
    }

    invertPendingAction() {
        // Ripristina la GUI dopo annulla
        let refresh = false;
        if (this.pendingActions) {
            while (this.pendingActions.length > 0) {
                const action = { ...this.pendingActions[0] };
                this.pendingActions.splice(0, 1);
                console.log(`***Invert pending action: ${action.recentDocDto?.name}, action: ${action.recentAction}`);
                if (action && action.recentDocDto && action.recentAction !== DOC_ACTION.NONE) {
                    this.snackBarService.isSnackbarEnabled = false;
                    switch (action.recentAction) {
                        case DOC_ACTION.TRASH:
                            this.setDeleteDate(action.recentDocDto, false);
                            break;
                        case DOC_ACTION.UNTRASH:
                            this.setDeleteDate(action.recentDocDto, true);
                            break;
                        case DOC_ACTION.REMOVE:
                        case DOC_ACTION.DELETE:
                            this.homeFilterService.allDocs.push(action.recentDocDto);


                            //this.filterRecents(this.currentRecentGroup);
                            break;
                    }
                    this.snackBarService.isSnackbarEnabled = true;
                    refresh = true;
                }
            }
            if (refresh) {
                this.homeFilterService.filterDocs();

            }


        }
    }

    public trashRecentGUI(doc: DocDto) {
        this.setDeleteDate(doc, true);
        this.shellEmittersService.onUpdateListDocs.emit();
    }

    public untrashRecentGUI(doc: DocDto) {
        this.setDeleteDate(doc, false);
        this.shellEmittersService.onUpdateListDocs.emit();
    }

    public removeRecentGUI(doc: DocDto) {
        return new Promise((resolve, reject) => {
            this.confirmationService.confirm(
                this.translateService.instant(extract('WARNING')),
                this.translateService.instant(extract('TRASH_REMOVE_CONFIRM')),
                this.translateService.instant(extract('BUTTON_OK')),
                this.translateService.instant(extract('CANCEL'))
            ).subscribe({
                next: (result) => {
                    if (result) {
                        this.discardRecentGUI(doc);
                    }
                    this.shellEmittersService.onUpdateListDocs.emit();
                    return resolve(result);
                }
            });
        });
    }


    public deleteRecentGUI(doc: DocDto): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.confirmationService.confirm(
                this.translateService.instant(extract('WARNING')),
                this.translateService.instant(extract('TRASH_DELETE_CONFIRM')),
                this.translateService.instant(extract('BUTTON_OK')),
                this.translateService.instant(extract('CANCEL'))
            ).subscribe({
                next: (result) => {
                    if (result) {
                        this.discardRecentGUI(doc);
                    }
                    this.shellEmittersService.onUpdateListDocs.emit();
                    return resolve(result);
                },
                error: (error) => {
                    return reject(error);
                }
            });
        });
    }

    public setDeleteDate(doc: DocDto, isDeleted: boolean) {
        if (doc) {
            doc.lastOpened = new Date();
            doc.deleteDate = (isDeleted ? new Date() : null);
            doc.fixDate = new Date(0);
            this.homeFilterService.filterDocs();
            this.shellEmittersService.onUpdateListDocs.emit();
            // this.filterRecents(this.currentRecentGroup);
        }
        const message = this.translateService.instant(isDeleted ? 'MSG_TRASHED_MAP' : 'MSG_UNTRASHED_MAP');
        const action = this.translateService.instant('CANCEL');
        this.snackBarService.openSnackBar(message, action, '', 'center', this.executePendingActions.bind(this), this.invertPendingAction.bind(this));
    }

    private discardRecentGUI(doc: DocDto) {
        // const doc = this.filter.allDocs.find(doc => doc.id === docId);
        this.homeFilterService.allDocs.forEach(d => {
            if (d.id === doc.id) {
                const index = this.homeFilterService.allDocs.indexOf(doc, 0);
                if (index > -1) {
                    this.homeFilterService.allDocs.splice(index, 1);
                }
            }
        });
        // this.filterRecents(this.currentRecentGroup);
        this.homeFilterService.filterDocs();
        const msgId = (doc && doc.isMine ? 'MSG_DELETED_MAP' : 'MSG_REMOVED_MAP');
        const message = this.translateService.instant(msgId);
        const action = this.translateService.instant('CANCEL');
        this.snackBarService.openSnackBar(message, action, '', 'center', this.executePendingActions.bind(this), this.invertPendingAction.bind(this));
    }

    public trashOrRestoreRecentOnDB(docId: string, operation: 'trash' | 'restore') {
        return new Promise((resolve, reject) => {
            if (this.trashRecentSubscription) { this.trashRecentSubscription.unsubscribe(); }
            this.removeRecentSubscription = this.apiService.trashRecent(docId, operation).subscribe((res: any) => {
                console.log('trashOrRestoreRecentOnDB OK')
                return resolve(true);
            }, (error: any) => {
                console.error('trashOrRestoreRecentOnDB() ERROR: ' + error);
                return resolve(false);
            });
        });
    }

    private removeOrDeleteRecentOnDB(docId: string) {
        return new Promise((resolve, reject) => {
            if (this.removeRecentSubscription) { this.removeRecentSubscription.unsubscribe(); }
            this.removeRecentSubscription = this.apiService.removeRecent(docId).subscribe((res: any) => {
                console.info('removeOrDeleteRecentOnDB OK')
                return resolve(true);
            }, (error: any) => {
                console.error('removeOrDeleteRecentOnDB() ERROR: ' + error);
                return resolve(false);
            });
        });
    }
}